"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SubTitle = _ref => {
  let {
    centered,
    right,
    children,
    text,
    className,
    fontContainer,
    size,
    renderAs
  } = _ref;
  let renderAsTemp = renderAs;
  if (renderAs.startsWith('h') && size >= 1 && size <= 6) {
    renderAsTemp = `h${size}`;
  }
  const RenderAs = renderAsTemp;
  let isCentered = fontContainer && fontContainer.indexOf('text_align:center') > -1;
  if (typeof centered !== 'undefined') {
    isCentered = centered;
  }
  if (right) {
    isCentered = false;
  }
  const sizeClassName = size >= 1 && size <= 6 ? `is-${size}` : '';
  const propsWithAria = {};
  propsWithAria['aria-level'] = size;
  if (text) {
    return /*#__PURE__*/_react.default.createElement(RenderAs, _extends({
      role: "heading",
      className: `subtitle ${sizeClassName} is-fullwidth${isCentered ? ' has-text-centered' : ''}${right ? ' has-text-right' : ''} ${className}`,
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize(text, {
          USE_PROFILES: {
            html: true
          }
        })
      }
    }, propsWithAria));
  }
  return /*#__PURE__*/_react.default.createElement(RenderAs, _extends({
    role: "heading",
    className: `subtitle ${sizeClassName} is-fullwidth${isCentered ? ' has-text-centered' : ''}${right ? ' has-text-right' : ''} ${className}`
  }, propsWithAria), children);
};
SubTitle.propTypes = {
  className: _propTypes.default.string,
  text: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  fontContainer: _propTypes.default.string,
  centered: _propTypes.default.bool,
  right: _propTypes.default.bool,
  size: _propTypes.default.number,
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
};
SubTitle.defaultProps = {
  renderAs: 'h2'
};
var _default = exports.default = (0, _CoreProps.withUiProps)(SubTitle);
//# sourceMappingURL=SubTitle.js.map